import { createSelector } from "reselect"

import { selectActiveTeeupId } from "@selectors/activeTeeup"

export const selectAgendaState = state => state?.agenda?.byCoId || {}

export const selectAgendaItemsByCoId = coId =>
  createSelector(selectAgendaState, byCoId => byCoId[coId]?.items || [])

export const selectAgendaLoadingByCoId = coId =>
  createSelector(selectAgendaState, byCoId => !!byCoId[coId]?.loading)

// Convenience: the ACTIVE teeup's agenda (the common case -- the TeeUp detail sections).
export const selectActiveTeeupAgendaItems = createSelector(
  selectAgendaState,
  selectActiveTeeupId,
  (byCoId, coId) => byCoId[coId]?.items || []
)

export const selectActiveTeeupAgendaLoading = createSelector(
  selectAgendaState,
  selectActiveTeeupId,
  (byCoId, coId) => !!byCoId[coId]?.loading
)
